import { UnknownAction, Dispatch, Middleware } from 'redux';
import { service } from '@src/service/index.js';
import type { RootState } from '@src/store/index.js';

export const tracker: Middleware<unknown, RootState> = () => (next) => (action) => {
  const ret = next(action) as Dispatch;
  service.tracker.reduxActionListener(action as UnknownAction);
  return ret;
};
